import { gql }  from '@apollo/client';

const SHOW_LAB_VENDORS = gql`
  query ($id: ID!) {
    member(id: $id) {
      labVendors {
        id
        sourceVendorId
        vendorNm
      }
      preferredLabVendor {
        id
        sourceVendorId
        vendorNm
      }
    }
  }
`;

export default SHOW_LAB_VENDORS;
